import { atom } from "nanostores";

export type BlockWaitingProgress = {
  currentBlock: number;
  targetBlock: number;
  isWaiting: boolean;
};

const $blockWaitingProgressAtom = atom<BlockWaitingProgress | null>(null);

export function getBlockWaitingProgress(): BlockWaitingProgress | null {
  return $blockWaitingProgressAtom.get();
}

export function setBlockWaitingProgress(progress: BlockWaitingProgress | null) {
  $blockWaitingProgressAtom.set(progress);
}

export function useBlockWaitingProgress() {
  const [progress, setProgress] = React.useState<BlockWaitingProgress | null>(null);

  React.useEffect(() => {
    const unsubscribe = $blockWaitingProgressAtom.subscribe(setProgress);
    return unsubscribe;
  }, []);

  return progress;
}

import React from "react";